import { useDrugs } from '@hook'
import { yupResolver } from '@hookform/resolvers/yup'
import { useAppSelector } from '@store/hooks'
import { FormButton, FormInputField, Modal, SelectInputField } from '@ui'
import { concatenateStrengthsConcise, getError, showToast } from '@util'
import { FormProvider, useForm } from 'react-hook-form'
import * as yup from 'yup'

export const drugSchema = yup.object({
  description: yup.string(),
  name: yup.string().required('Name is required'),
  form: yup.string().required('Form is required'),
  strength: yup.string().required('Strength is required')
})

export type DrugInputProps = yup.InferType<typeof drugSchema>

type Props = {
  onClose: () => void
  defaultData?: DrugInputProps
  id?: string
}

export const DrugModal = ({ onClose, defaultData, id }: Props) => {
  const isEdit = !!id
  const defaultValues = defaultData
    ? {
        ...defaultData,
        strength: defaultData.strength || concatenateStrengthsConcise((defaultData as any).api_doses)
      }
    : {
        strength: ''
      }
  const methods = useForm({
    defaultValues: defaultValues as DrugInputProps,
    resolver: yupResolver(drugSchema)
  })
  const { handleSubmit, formState } = methods

  console.log(formState.errors)

  const { dosage_forms } = useAppSelector(state => state.config)
  const { createDrug, updateDrug } = useDrugs()

  const onSubmit = async (data: any) => {
    const payload = {
      data: {
        attributes: {
          ...data
        },
        type: 'drug'
      }
    }
    try {
      if (isEdit) {
        await updateDrug({ formVal: payload, id: id || '' })
        showToast('Drug updated successfully')
      } else {
        await createDrug(payload)
        showToast('Drug created successfully')
      }
      onClose()
    } catch (error) {
      getError(error)
    }
  }

  return (
    <FormProvider {...methods}>
      <Modal onClose={onClose} title={isEdit ? 'Edit Drug' : 'Add Drug'}>
        <form
          className="w-full min-w-0 md:max-w-[500px] flex flex-1 flex-col overflow-auto"
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className="flex flex-1 flex-col gap-4 overflow-auto p-6">
            <div>
              <FormInputField label="Name" name="name" />
            </div>
            <div className="flex flex-col gap-2">
              <FormInputField label="Strength" name="strength" placeholder="e.g. 500mg or 120/30mg" />
            </div>
            <div>
              <SelectInputField
                className="capitalize"
                label="Form"
                name="form"
                options={dosage_forms || []}
                placeholder="Choose dosage form"
              />
            </div>
            {/* <div>
              <TextAreaField label="Description" name="description" />
            </div> */}
          </div>
          <FormButton isLoading={formState.isSubmitting} onClose={onClose} submit={isEdit ? 'Update' : 'Save'} />
        </form>
      </Modal>
    </FormProvider>
  )
}

export default DrugModal
